<div class="table-component flex flex-grow flex-column" *ngIf="newTableMode === false">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-xxs" fxLayoutGap="2%">
        <!-- <div>
            <p class="upper bold-font" style="font-size: 20px; min-width: 230px;">{{ tableTitle }}:</p>
        </div> -->
        <div class="search-wrapper" fxLayout="row" fxLayoutAlign="center center">
            <input #filter placeholder="Wpisz szukaną frazę" class="search-bar" [formControl]="filterControl"
                (keyup.enter)="filterByTrigger()" />
            <mat-icon class="text-primary" (click)="clearFilter()">close</mat-icon>
            <mat-icon class="text-primary" (click)="filterByTrigger()">search</mat-icon>
        </div>
        <div *ngIf="hasAddButton">
            <button class="upper button-primary" style="min-width: 150px;" routerLink="add">
                nowy koszyk
            </button>
        </div>
    </div>

    <div class="table-wrapper flex flex-column flex-grow">
        <inner-loader [isActive]="isLoadingResults"></inner-loader>
        <mat-table #table id="table" [dataSource]="data" class="mat-cell flex flex-grow flex-column"
            [class.competitor-table]="isComp">
            <ng-container *ngFor="let column of columnsData" [matColumnDef]="column.columnDef">
                <mat-header-cell *matHeaderCellDef [fxFlex]="column.width">
                    <pr-drop-select [placeholder]="column.header" class="cell-header-wrapper" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlexFill [optLabel]="column.header"
                        [selectName]="selectSortName(column)" (change)="sortChange($event)"
                        [filterDef]="column.filterValue" (filterChanged)="selFilterChanged($event)"
                        [isSelected]="checkIfSelected(column.columnDef)">
                    </pr-drop-select>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" [fxFlex]="column.width"
                    [matTooltip]="getTooltip(column, row[column.columnDef])"
                    [matTooltipDisabled]="!column.tooltipEnabled">
                    <div *ngIf="column.type && column.type === 'date'">
                        {{
                            generalService.parseDate(row[column.columnDef]) ||
                                '-'
                        }}
                    </div>
                    <div *ngIf="column.type && column.type === 'datetime'">
                        {{
                            generalService.parseDateWithTime(
                                row[column.columnDef]
                            ) || '-'
                        }}
                    </div>
                    <div *ngIf="column.type && column.type === 'vat'" class="percentage-suf">
                        {{
                            generalService.parseVAT(row[column.columnDef])
                                | number: '.0-0'
                        }}
                    </div>
                    <div *ngIf="column.type && column.type === 'number'">
                        {{ row[column.columnDef] || '-' }}
                    </div>
                    <div *ngIf="!column.suffix && !column.type">
                        {{ row[column.columnDef] || '-' }}
                    </div>
                    <div *ngIf="column.type && column.type === 'margin'" class="percentage-suf">
                        {{
                            generalService.parseVAT(row[column.columnDef])
                                | number: '.1-1'
                        }}
                    </div>
                    <div *ngIf="
                            !column.type &&
                            column.suffix &&
                            column.suffix === 'percentage'
                        " class="percentage-suf">
                        {{ row[column.columnDef] || '-' }}
                    </div>
                    <div *ngIf="column.suffix && column.suffix === 'currency'" class="currency-suf">
                        {{ (row[column.columnDef] | number: '.2-2') || '-' }}
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedColumns" (click)="notImplemented(row)">
            </mat-row>
        </mat-table>

        <mat-toolbar>
            <mat-toolbar-row>
                <!-- here select button -->
                <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 25, 50, 100]" [length]="itemsLength"
                    (page)="pageEvent = getPaginatorData($event)"></mat-paginator>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
</div>

<div class="newtable-wrapper" *ngIf="newTableMode === true">

    <!--    <p-table #dt [columns]="columnsData" stateStorage="local" [stateKey]="tableId" [value]="tableData" [reorderableColumns]="true"-->
    <!--             [resizableColumns]="true" [lazy]="true" (onLazyLoad)="this.loadData($event)" (onColReorder)="this.onColReoder($event)">-->
    <!--        <ng-template pTemplate="caption">-->
    <!--            <div style="text-align:left">-->
    <!--            </div>-->
    <!--        </ng-template>-->
    <!--        <ng-template pTemplate="header" let-columns>-->
    <!--            <tr>-->
    <!--                <th *ngFor="let col of columns" pReorderableColumn pResizableColumn>-->
    <!--                    {{ this.getFormattedHeader(col.header) }}-->
    <!--                </th>-->
    <!--            </tr>-->
    <!--        </ng-template>-->
    <!--        <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">-->
    <!--            <tr>-->
    <!--                <td *ngFor="let col of columns" class="ui-resizable-column">-->
    <!--&lt;!&ndash;                    {{rowData[col.field]}}&ndash;&gt;-->
    <!--                    {{ this.getFormattedData(rowData[col.columnDef], col) }}-->
    <!--                </td>-->
    <!--            </tr>-->
    <!--        </ng-template>-->
    <!--    </p-table>-->



    <p-table
        #dt
        class="pr-table"
        [columns]="selectedColumns"
        [value]="tableData"
        [loading]="isLoading"
        [resizableColumns]="true"
        [lazy]="true"
        (onLazyLoad)="this.loadData($event)"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        selectionMode="single"
        [reorderableColumns]="true"
        [totalRecords]="this.totalRecords"
        [scrollable]="true"
        scrollHeight="100%"
        stateStorage="local"
        [stateKey]="tableId"
        (onColReorder)="this.onColReorder($event)"
        (onColResize)="this.onColResize($event)"
        [filterDelay]="800"
    >
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col *ngFor="let col of columns" [style.width]="col.width + '%'">
            </colgroup>
        </ng-template>

        <ng-template pTemplate="caption">
            <div class="table-header" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxFlex>
                    <p-multiSelect [options]="columnsData" [formControl]="selectedColumnsControl" optionLabel="header"
                                   selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}" defaultLabel="Choose Columns"></p-multiSelect>
                </div>
                <div
                    class="search-wrapper"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    fxFlex
                >
                    <input
                        matInput
                        #filter
                        placeholder="Wpisz szukaną frazę"
                        class="search-bar"
                        [formControl]="filterGlobalControl"
                        (keyup.enter)="this.loadData(dt.createLazyLoadMetadata())"
                    />
                    <mat-icon class="text-primary" (click)="clearGlobalFilter()"
                    >close</mat-icon
                    >
                    <mat-icon
                        class="text-primary"
                        (click)="this.loadData(dt.createLazyLoadMetadata())"
                    >search</mat-icon
                    >
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" pResizableColumn pReorderableColumn [pSortableColumn]="col.columnDef">
                    {{ this.getFormattedHeader(col.header) }}
                    <p-sortIcon [field]="col.columnDef"></p-sortIcon>
                </th>
            </tr>
            <tr>
                <th *ngFor="let col of columns" [ngSwitch]="col.dataType">
                    <input pInputText type="text" (input)="
                            dt.filter(
                                $event.target.value,
                                col.columnDef,
                                'contains'
                            )
                        "
                        class="searchColumnText p-column-filter"
                    />

                    <!-- <p-multiSelect
                        *ngIf="col.filterValue !== undefined"
                        [options]="
                            this.getFilterOptions(col.filterValue) | async
                        "
                        class="searchColumnText"
                    > -->
                    <!-- (onChange)="
                            dt.filter($event.value, col.field, 'equals')
                        " -->
                    <!-- </p-multiSelect> -->
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-columns="columns">
            <tr>
                <td
                    [ngClass]="'pr-table-coltype-' + column.dataType"
                    class="ui-resizable-column"
                    *ngFor="let column of columns"
                >
<!--                    TODO: zmienic na property w modelu a nie metode-->
                    <div *ngIf="column.type && column.type === 'date'">
                        {{
                        generalService.parseDate(row[column.columnDef]) ||
                        '-'
                        }}
                    </div>
                    <div *ngIf="column.type && column.type === 'datetime'">
                        {{
                        generalService.parseDateWithTime(
                            row[column.columnDef]
                        ) || '-'
                        }}
                    </div>
                    <div
                        *ngIf="column.type && column.type === 'vat'"
                        class="percentage-suf"
                    >
                        {{
                        generalService.parseVAT(row[column.columnDef])
                            | number: '.0-0'
                        }}
                    </div>
                    <div *ngIf="column.type && column.type === 'number'">
                        {{ row[column.columnDef] || '-' }}
                    </div>
                    <div *ngIf="!column.suffix && !column.type">
                        {{ row[column.columnDef] || '-' }}
                    </div>
                    <div
                        *ngIf="column.type && column.type === 'margin'"
                        class="percentage-suf"
                    >
                        {{
                        generalService.parseVAT(row[column.columnDef])
                            | number: '.1-1'
                        }}
                    </div>
                    <div
                        *ngIf="
                            !column.type &&
                            column.suffix &&
                            column.suffix === 'percentage'
                        "
                        class="percentage-suf"
                    >
                        {{ row[column.columnDef] || '-' }}
                    </div>
                    <div
                        *ngIf="column.suffix && column.suffix === 'currency'"
                        class="currency-suf"
                    >
                        {{ (row[column.columnDef] | number: '.2-2') || '-' }}
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
